import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { getSavedFiltersQueryOptions } from '~/data/savedFilter';
import { getTaxCodesQueryOptions } from '~/data/taxCode';

import { mapTaxCodesFiltersToPayload, TaxCodesPage } from '~/modules/taxCodes';
import { UNIVERSAL_FILTER_TYPES } from '~/modules/universalFilters';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';
import {
  defaultTaxCodesSearch,
  type TaxCodesSearch,
  zodTaxCodesSearchSchema,
} from './-searchParams';

const title = i18n.t(($) => $.pageTitle, { ns: 'taxCodes' });

export const Route = createFileRoute('/(main)/settings/masterdata/tax-codes/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/tax-codes/',
    ...routeParams,
  }),
  component: TaxCodesPage,
  head: () => getRouteHead(title),
  loader: async ({ context: { queryClient }, deps }) => {
    const { limit, orderBy, page, savedFilterId, sortOrder } =
      deps as TaxCodesSearch;

    void queryClient
      .query(
        getSavedFiltersQueryOptions({
          queryParams: {
            type: UNIVERSAL_FILTER_TYPES.taxCodes,
          },
          options: {
            meta: {
              suppressErrorForErrorCodes: [422],
            },
          },
        }),
      )
      .catch(() => undefined);

    if (savedFilterId) {
      return;
    }

    void queryClient
      .query(
        getTaxCodesQueryOptions({
          queryParams: {
            ...mapTaxCodesFiltersToPayload([], ''),
            limit,
            offset: page * limit,
            orderBy,
            sortOrder,
          },
        }),
      )
      .catch(() => undefined);
  },
  loaderDeps: ({ search }) => search,
  search: {
    middlewares: [stripSearchParams(defaultTaxCodesSearch)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodTaxCodesSearchSchema,
});

export const MASTERDATA_TAX_CODES = buildRouteExport({
  Route,
  ...routeParams,
});
